<template>
  <div class="matrix-scale" ref="container">
    <div v-for="(row,index) in issue.items" :key="row.id" class="mb-6">
      <div class="leading-22 text-theme-black-650 flex justify-between" :style="{width:labelWidth+'px'}">
        <div :style="{width:labelHeadWidth}" v-html="row.content.richText" ></div>
        <template v-if="issue.enabledAuxiliaryColumn">
          <div class="text-right" :style="{width:labelHeadWidth}" v-html="issue.auxiliaryColumns[index].content.richText"></div>
        </template>
      </div>
      <scale-item
          class="mt-1"
          :labels="labels"
          :select-value="row.value"
          :show-value="issue.show_option_value"
          :show-desc="issue.show_option_desc"
          :style-handler="getActiveColor"
          @click="onChangeSelectVal(row, $event)"
      >
        <template v-slot:unknown>
          <van-radio-group :value="row.value">
            <van-radio name="unknown" @click="row.value = 'unknown'">
              <template v-slot:icon="{ checked }">
                <icon-radio :value="checked" />
              </template>
            </van-radio>
          </van-radio-group>
        </template>
      </scale-item>
    </div>
  </div>
</template>

<script>
import ScaleItem from '@/questions/scale/ScaleItem'
import IconRadio from '@/components/base/IconRadio'

export default {
  name: 'MatrixScale',
  changeExpr: 'isSelectAll',
  components: { IconRadio, ScaleItem },
  data(){
    return {
      labelWidth: 0
    }
  },
  computed: {
    labelHeadWidth(){
      if(!this.issue.enabledAuxiliaryColumn) return this.labelWidth + 'px'
      return ((this.labelWidth / 2) | 0) + 'px'
    },
    wrapPaddingRight() {
      return Math.max((this.issue.unknown_text || '').length * 20, 30) + 'px'
    },
    isSelectAll() {
      let val = this.issue.items.every(item => item.value !== null)
      if (!val) return 'false'
      return this.issue.items.map(i => i.value).join('-')
    },
    labels() {
      const labels = this.issue.labels.slice()
      if (this.issue.show_unknown) {
        labels.push({
          text: this.issue.unknown_text,
          num: 'unknown'
        })
      }
      return labels
    }
  },
  methods: {
    getActiveColor(activeValue, idx) {
      return this.issue.getActiveColor(activeValue, idx)
    },
    onChangeSelectVal(row, item) {
      row.value = item.id
    },
    init() {
      const container = this.$refs.container
      const containerWidth = container.clientWidth
      const items = container.getElementsByClassName('label-wrap')
      const itemWidth = (containerWidth / this.labels.length) | 0
      if(this.issue.show_unknown) {
        this.labelWidth = itemWidth * (this.labels.length-1)
      }else {
        this.labelWidth = itemWidth * this.labels.length
      }
      for (let i = 0; i < items.length; i++) {
        const item = items[i]
        item.style.width = itemWidth + 'px'
      }
    }
  },
  mounted() {
    this.init()
  }
}
</script>
